

/**
 *
 */
export const SessionActionTypes = {
    CREATE_SESSION: 'CREATE_SESSION',
    CLOSE_SESSION: 'CLOSE_SESSION',
};



/**
 *
 */
export const ServerActionTypes = {
    UPDATE_SERVER_DATA: 'UPDATE_SERVER_DATA',
    UPDATE_SCHEDULED_ORDERS: 'UPDATE_SCHEDULED_ORDERS',
    REQUEST_SCHEDULED_ORDERS_UPDATE: 'REQUEST_SCHEDULED_ORDERS_UPDATE',
};


/**
 *
 */
export const ApplicationActionTypes = {
    CLEAR_ORDER_SELECTED: 'CLEAR_ORDER_SELECTED',
    UPDATE_ORDER_SELECTED: 'UPDATE_ORDER_SELECTED',
    UPDATE_ORDER_HIGHLIGHTED: 'UPDATE_ORDER_HIGHLIGHTED',
    UPDATE_DRIVER_SELECTED: 'UPDATE_DRIVER_SELECTED',
    UPDATE_DRIVER_HIGHLIGHTED: 'UPDATE_DRIVER_HIGHLIGHTED',
    UPDATE_DRIVER_FILTERS: 'UPDATE_DRIVER_FILTERS',
    UPDATE_SCHEDULED_HIGHLIGHTED: 'UPDATE_SCHEDULED_HIGHLIGHTED',
    ACTION_SCHEDULED_FASTFORWARD: 'ACTION_SCHEDULED_FASTFORWARD',
    ACTION_SCHEDULED_CONFIRMATION: 'ACTION_SCHEDULED_CONFIRMATION',
};




// WEBPACK FOOTER //
// ./src/data/ActionTypes.js